"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowCheckBoxEditor_1 = require("../../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowNumericEditor_1 = require("../../../../../../../../shared/components/editors/CardRowNumericEditor");
var BrandPayProviderTrustZoneEditor = /** @class */ (function (_super) {
    __extends(BrandPayProviderTrustZoneEditor, _super);
    function BrandPayProviderTrustZoneEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        return _this;
    }
    BrandPayProviderTrustZoneEditor.prototype.componentWillMount = function () {
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    brand_pay_provider_id: _item.pay_provider_config_id,
                    brand_pay_provider_title: _item.pay_provider_config_title,
                    app_trust_zone_code: _item.trust_zone_code,
                    app_trust_zone_title: _item.trust_zone_title,
                    order_number: _item.order_number,
                    is_locked: _item.is_locked,
                    description: _item.description
                });
            }
        }
        else {
            this.setState({
                brand_pay_provider_id: 0,
                brand_pay_provider_title: "",
                app_trust_zone_code: 0,
                app_trust_zone_title: "",
                order_number: 0,
                is_locked: false,
                description: ""
            });
        }
        this.doReSetRules();
    };
    BrandPayProviderTrustZoneEditor.prototype.doReSetRules = function () {
        this.setState({
            brand_pay_provider_rules: { isError: false },
            app_trust_zone_rules: { isError: false }
        });
    };
    BrandPayProviderTrustZoneEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.brand_pay_provider_id <= 0) || (this.state.brand_pay_provider_title.length === 0)) {
            this.setState({
                brand_pay_provider_rules: { isError: true, errorMessage: "Платежный провайдер не выбран!" }
            });
            return false;
        }
        if ((this.state.app_trust_zone_code <= 0) || (this.state.app_trust_zone_title.length === 0)) {
            this.setState({
                app_trust_zone_rules: { isError: true, errorMessage: "Зона доверия не выбрана!" }
            });
            return false;
        }
        return true;
    };
    BrandPayProviderTrustZoneEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                order_number: this.state.order_number,
                is_locked: this.state.is_locked,
                description: this.state.description,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Платежный провайдер зоны доверия бренда был изменен!");
            });
        }
    };
    BrandPayProviderTrustZoneEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                brand_id: this.props.rootRecord.key,
                brand_pay_provider_id: this.state.brand_pay_provider_id,
                app_trust_zone_code: this.state.app_trust_zone_code,
                order_number: this.state.order_number,
                is_locked: this.state.is_locked,
                description: this.state.description,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Платежный провайдер зоны доверия бренда добавлен!");
            });
        }
    };
    BrandPayProviderTrustZoneEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandPayProviderTrustZoneEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить платежный провайдер в зону доверия";
        }
        else {
            return "Изменить платежный провайдер в зоне доверия";
        }
    };
    BrandPayProviderTrustZoneEditor.prototype.getMainEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Провайдер:", placeholder: "Выберите провайдера" }, value: { key: this.state.brand_pay_provider_id, value: this.state.brand_pay_provider_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_pay_provider_id: newVal.key,
                        brand_pay_provider_title: newVal.value,
                        brand_pay_provider_rules: { isError: false }
                    });
                }, items: this.props.pay_providers_avail, required: true, rules: this.state.brand_pay_provider_rules, disabled: this.props.record != null }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Зона доверия:", placeholder: "Выберите зону доверия" }, value: { key: this.state.app_trust_zone_code, value: this.state.app_trust_zone_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_trust_zone_code: newVal.key,
                        app_trust_zone_title: newVal.value,
                        app_trust_zone_rules: { isError: false }
                    });
                }, items: this.props.trust_zones_avail, required: true, rules: this.state.brand_pay_provider_rules, disabled: this.props.record != null }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Номер п/п", placeholder: "Введите номер по порядку" }, values: { max: 999999, min: 0, value: this.state.order_number }, onValueChanged: function (newVal) {
                    _this.setState({
                        order_number: newVal
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Платежный провайдер в зоне доверия заблокирован", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            this.getDownButtons()));
    };
    BrandPayProviderTrustZoneEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    BrandPayProviderTrustZoneEditor.prototype.render = function () {
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 500 }, this.getMainEditContent()));
    };
    return BrandPayProviderTrustZoneEditor;
}(React.Component));
exports.default = BrandPayProviderTrustZoneEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/options/pay_providers_trust_zones/BrandPayProviderByTrustZoneEditor.tsx
// module id = 1810
// module chunks = 0